/* eslint-disable tailwindcss/no-arbitrary-value */
import { CmsImage } from '@hyphengroup/cms-components/components/CmsImage';
import classNames from 'classnames';

export const RewardCardImage: React.FC<{
  imageSrc: string;
  altText: string;
  size: 'small' | 'medium';
}> = ({ imageSrc, altText, size }) => {
  const wrapperSizeClasses = classNames({
    'w-[74px] md:w-[105px]': size === 'medium',
    'w-[50px] md:w-[58px]': size === 'small',
  });

  return (
    <div
      className={classNames(
        'flex h-20 shrink-0 items-center justify-center rounded md:h-22',
        wrapperSizeClasses,
      )}
    >
      <CmsImage
        alt={altText}
        className="max-h-full max-w-full object-contain"
        height={88}
        sizes={{ _: '74px', sm: '105px' }}
        src={imageSrc}
        width={105}
      />
    </div>
  );
};
